import * as React from "react";

const ChannelIcon = (props) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.52 7.11H21.48M8.52 2.11V6.97M15.48 2.11V6.52M22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M9.75 14.448V13.248C9.75 11.708 10.84 11.078 12.17 11.848L13.21 12.448L14.25 13.048C15.58 13.818 15.58 15.078 14.25 15.848L13.21 16.448L12.17 17.048C10.84 17.818 9.75 17.188 9.75 15.648V14.448Z" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

export default ChannelIcon;
